import React from "react";
import { TextField, MenuItem, Box } from "@mui/material";
import Labels from "./Labels";
import { getColor } from "../../style/color/color";
import { fonts } from "../../style/fonts/fonts";

const Dropdown = ({ label, value, onChange, options }) => (
  <Box sx={{ my: 1, textAlign: "center" }}>
    <Labels text={label} />
    <TextField
      select
      variant="outlined"
      value={value}
      onChange={onChange}
      InputProps={{
        sx: {
          height: "40px",
          color: getColor.NeutralDark700,
          fontSize: 16,
          fontFamily: fonts.manrope,
          fontWeight: "700",
        },
      }}
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          borderRadius: 2,
          fontSize: "10px",
          height: "40px",
          "& input": {
            padding: "5px",
          },
        },
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  </Box>
);

export default Dropdown;
